import { useContext, useState, useEffect } from  "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../stores/root_store";
import { Success } from './FancyToast';
import Stack from '@mui/joy/Stack';
import useUserIdentity from "../hooks/useUserIdentity";
import HomeClient from "./HomeClient";
import HomeAssistant from "./HomeAssistant";

// import { useNavigate } from "react-router-dom";
// import CardActions from '@mui/joy/CardActions';
// import Button from '@mui/joy/Button';
// import Divider from '@mui/joy/Divider';
// import CopyFancyHandsBullets from "./CopyFancyHandsBullets";
// import CardLoggedOut from './CardLoggedOut';
// import { User } from "../stores/user_store";

const HomeLoggedIn = observer(() => {
    const userIdentityStore = useContext(RootStoreContext).userIdentityStore;
    const identities = userIdentityStore.getUserIdentities();
    const { currentIdentity } = useUserIdentity();

    const [fetchedIdentities, setFetchedIdentities] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(!fetchedIdentities) {
            userIdentityStore.fetchUserIdentities().then(() => {
            setFetchedIdentities(true);

            });
        }

    }, [fetchedIdentities, setFetchedIdentities, userIdentityStore]);

    useEffect(() => {

        document.title = "Home";


        if(fetchedIdentities) {
            if(!identities.length) {
                Success("Welcome! Please tell us about yourself.");
                navigate("/identity/new");
            }
        }

    }, [fetchedIdentities, identities.length, navigate]);


    return (
        <Stack >

            { currentIdentity.role == 'client' &&
                <HomeClient /> }

            { currentIdentity.role == 'assistant' &&
                <HomeAssistant /> }
        </Stack>

    );
});
export default HomeLoggedIn;
